import React from "react";
import { useDispatch, useSelector } from "react-redux";
import classnames from "classnames";

import { useMount } from "@sportal/cdk/hooks";
import { Icon } from "../icon/Icon";
import { Tooltip } from "../tooltip/Tooltip";

import { getRoamingLimit } from "../../store/devices/logicalDevices";
import { useIntlTranslate } from "../../hooks";
import { RoamingLimitNearingWarning } from "./RoamingLimitNearingWarning";
import {
  fetchRoamingLimit,
  getRoamingDevicesCount,
  isRoamingCountApproachingLimit,
  isRoamingLimitReached,
} from "../../store/devices/logicalDevices";

import "./RoamingInfo.scss";

export function RoamingInfo() {
  const count = useSelector(getRoamingDevicesCount);
  const limit = useSelector(getRoamingLimit);
  const isLimitApproaching = useSelector(isRoamingCountApproachingLimit);
  const isLimitReached = useSelector(isRoamingLimitReached);

  const dispatch = useDispatch();
  const translate = useIntlTranslate();

  useMount(() => {
    dispatch(fetchRoamingLimit());
  });

  if (!limit) return null;

  const tooltipText = translate("roaming_counter_tooltip");
  const ariaText = translate("roaming_counter_tooltip_aria", {
    count,
    limit,
  });
  const counterClasses = classnames("roaming-info", {
    "roaming-info--warning": isLimitReached,
  });

  return (
    <div className={counterClasses}>
      <div className={"roaming-limit"}>
        <Tooltip
          theme="dark"
          content={tooltipText}
          aria-label={tooltipText}
          role="tooltip"
        >
          <span className="sr-only">{ariaText}</span>
          <RoamingCounterIcon />
          <span aria-hidden="true">
            {count}/{limit}
          </span>
        </Tooltip>
      </div>
      {isLimitApproaching && <RoamingLimitNearingWarning />}
    </div>
  );
}

function RoamingCounterIcon() {
  return (
    <span className="roaming-limit__icon" aria-hidden="true">
      <Icon icon="fa-regular fa-signal roaming-counter-icon__bars" />
    </span>
  );
}
